import { PureComponent } from "react";

import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    type GridColumn,
    GridColumnType,
    type IClientGridColumn,
} from "commonComponents/utilities/Grid/GridContainer.types";

interface IAreaProps {
    value: number;
    unit: string;
}

class AreaCell extends PureComponent<IGridCellRenderProps<IAreaProps, GridColumn<IAreaProps>>> {
    render() {
        const { cellValue } = this.props;
        if (!cellValue) {
            return null;
        }
        return cellValue.value ? (
            <>
                {cellValue.value} {cellValue.unit}
            </>
        ) : null;
    }
}

export const columnArea: IClientGridColumn<IAreaProps> = {
    columnType: GridColumnType.area,
    Cell: AreaCell,
};
